import { initializeFirebaseApp } from '@elka/firebase';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
  functionsRegion: import.meta.env.VITE_FIREBASE_FUNCTIONS_REGION,
};

const { app, db, auth, storage, functions } = initializeFirebaseApp(
  firebaseConfig,
  import.meta.env.DEV,
  { offline: true }
);

// Default is 10 min of silent retries; a dead connection should fall back to the offline
// photo queue (lib/offline/photoQueue) quickly instead of hanging the save button.
storage.maxUploadRetryTime = 15_000;

export { app, db, auth, storage, functions };
